import React from 'react';
import NavBar from '../components/navbar';
import { Paper, TextField, Button, Typography } from '@material-ui/core';
import '../styles/registration.css';
import * as auth from '../data/firebaseAuth';

const rootClass = "registration root";
const titleClass = "registration title";
const inputClass = "registration input";
const submitClass = "registration submit";
const successClass = "registration success";


class Registration extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            email: "",
            password: "",
            confirmPassword: "",
            name: "",
            passwordVisible: false,
            processingRegistration: false,
            sentEmail: false,
        }
        this.registrationBtn = this.registrationBtn.bind(this);
    }

    textHandler = name => event => {
        this.setState({ [name]: event.target.value });
    };

    render() {
        if (this.state.sentEmail) {
            setTimeout(() => this.props.history.push('/'), 10000);
            return (
                <>
                    <NavBar />
                    <div className={successClass}>
                        <Typography variant="h4">
                            Registration almost completed.<br />
                            We've sent an link to your E-Mail.<br />
                            Please click on the link to confirm your account.
                        </Typography>
                        <Typography variant="h6">You will be redirected in 10 seconds.</Typography>
                    </div>
                </>
            );
        }
        return (
            <>
                <NavBar />
                <Paper className={rootClass}>
                    <Typography variant="h3" className={titleClass}>Registrieren</Typography>
                    <TextField label="Nickname" value={this.state.name} onChange={this.textHandler('name')} type="text" className={inputClass} variant="outlined" required autoComplete="nickname" fullWidth></TextField>
                    <TextField label="Email" value={this.state.email} onChange={this.textHandler('email')} type="email" className={inputClass} variant="outlined" required autoComplete="email" fullWidth></TextField>
                    <TextField label="Passwort" value={this.state.password} onChange={this.textHandler('password')} type={this.state.passwordVisible ? "text" : "password"} className={inputClass} variant="outlined" required autoComplete="new-password" fullWidth></TextField>
                    <TextField label="Password bestätigen" error={this.state.password !== this.state.confirmPassword} value={this.state.confirmPassword} onChange={this.textHandler('confirmPassword')} type={this.state.passwordVisible ? "text" : "password"} className={inputClass} variant="outlined" required autoComplete="new-password" fullWidth></TextField>
                    <Button color="primary" className={submitClass} variant="contained" onClick={this.registrationBtn} disabled={this.state.processingRegistration} fullWidth>Registrieren</Button>
                </Paper>
            </>
        );
    }

    async registrationBtn() {
        if (this.state.password === this.state.confirmPassword) {
            await this.setState({ processingRegistration: true });
            await auth.register(this.state.email, this.state.password, this.state.name);
            await auth.login(this.state.email, this.state.password);
            auth.getCurrentUser().sendEmailVerification();
            await this.setState({ sentEmail: true });
        }
    }
}

export default Registration;